import { render } from "./create_questions.html?vue&type=template&id=8a832904&scoped=true&external"
import script from "./create_questions.js?vue&type=script&lang=js&external"
export * from "./create_questions.js?vue&type=script&lang=js&external"

import "./CreateQuestions.vue?vue&type=style&index=0&id=8a832904&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a832904"]])

export default __exports__